export default "__VITE_ASSET__BNcxiaef__"